<proffeo-ui-select
  (valueChange)="onSelectLanguage($event)"
  [optionTemplate]="languageOptionTemplate"
  [options]="languageOptions"
  [translateLabels]="false"
  [triggerTemplate]="languageTriggerTemplate"
  [value]="currentLanguage()"
  appearance="inline"
  class="group inline-flex min-w-4 min-h-3"
/>

<ng-template
  #languageTriggerTemplate
  let-selectedOptions="selectedOptions"
>
  @if (selectedOptions[0]; as selectedOption) {
    <img
      [ngSrc]="'img/flags/' + selectedOption.iconName + '.svg'"
      [alt]="selectedOption.label"
      width="20"
      height="15"
      class="opacity-75 drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)] group-hover:opacity-100"
    />
    @if (expanded()) {
      <p class="text-proffeo-on-action/75 group-hover:text-proffeo-on-action">{{ selectedOption.label }}</p>
    }
  }
</ng-template>

<ng-template
  #languageOptionTemplate
  let-option="option"
>
  <span class="flex items-center gap-2">
    <img
      [ngSrc]="'img/flags/' + option.iconName + '.svg'"
      [alt]="option.label"
      width="20"
      height="15"
      class="drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)]"
    />
    <p>{{ option.label }}</p>
  </span>
</ng-template>
